import BN from 'bignumber.js'
import dayjs from 'dayjs'
import { createAvatar } from '@dicebear/avatars'
import * as style from '@dicebear/avatars-jdenticon-sprites'
import config from '@/config'

export class Tools {
  /**
   * 地址省略
   * @param value 地址
   * @returns
   */
  static captureAddress (value: string, len = 4) {
    if (!value) {
      return '~'
    }

    return value.replace(/^(0x)(.*)/, (v1, v2, v3) => {
      const ellipsis = `${v3.substr(0, len)}...${v3.substr(-len, len)}`

      return `${v2}${ellipsis}`
    })
  }

  /**
   * 为数字补全位数
   * @param num 数字
   * @param len 长度
   */
  static numFillZero (num: number, len = 2) {
    return num.toString().padStart(len, '0')
  }

  /**
   * 金额 - 加精度处理
   * @param amount 金额
   * @param decimal 精度
   * @returns
   */
  static amountPlusDecimal (amount: string, decimal: number) {
    if (!amount) {
      return '~'
    }
    return new BN(amount).times(new BN(10).exponentiatedBy(decimal)).toString()
  }

  /**
   * 金额 - 去除精度处理
   * @param amount 金额
   * @param decimal 精度
   * @returns
   */
  static amountDivDecimal (amount: string, decimal: number) {
    if (!amount) {
      return '~'
    }

    const BNset = BN

    BNset.set({ DECIMAL_PLACES: config.decimal, ROUNDING_MODE: 1, EXPONENTIAL_AT: 20 })

    const pow = new BNset(10).exponentiatedBy(decimal).toString()

    return new BNset(amount).div(pow).toString()
  }

  /**
   * 金额格式化
   * @param amount 金额
   * @returns
   */
  static amountFormat (amount: string, decimal: number) {
    if (!amount) {
      return '~'
    }

    const amountDecimal = Tools.amountDivDecimal(amount, decimal)

    const amountDecimalArr = amountDecimal.split('.')

    const newAmountDecimal = [amountDecimalArr[0]]

    const totalLength = 8

    if (amountDecimalArr[1]) {
      if (new BN(amountDecimalArr[0]).eq('0')) {
        newAmountDecimal[1] = amountDecimalArr[1].substring(0, totalLength)
      } else if (amountDecimalArr[0].length < totalLength) {
        newAmountDecimal[1] = amountDecimalArr[1].substring(0, totalLength - newAmountDecimal[0].length)
      }
    }

    return new BN(newAmountDecimal.join('.')).toFormat()
  }

  /**
   * 格式化时间戳
   * @param timestamp 时间戳
   * @param format 格式
   * @returns
   */
  static timeFormat (timestamp: number, format = 'HH:mm') {
    if (!timestamp) {
      return '~'
    }

    let formatInit = 'MM-DD ' + format

    console.log(dayjs(timestamp).year())

    if (dayjs(timestamp).year() !== new Date().getFullYear()) {
      formatInit = 'YYYY-' + formatInit
    }

    return dayjs(timestamp).format(formatInit).valueOf()
  }

  /**
   * 生成头像
   * @param seed 地址
   * @returns
   */
  static generateAvatar (seed: string) {
    return createAvatar(style, { base64: true, seed })
  }

  /**
   * 检查为空
   * @param str
   * @returns
   */
  static checkNull (str: string) {
    if (!str) return '~'

    return str
  }

  /**
   * 获取字节长度
   * @param str
   */
  static byteLength (str: string) {
    // eslint-disable-next-line no-control-regex
    return str.replace(/[^\x00-\xff]/g, '01').length
  }
}
